import React from "react";
import i18n from "i18next";
import { useSnackbar, VariantType } from "notistack";

let useSnackbarRef: ReturnType<typeof useSnackbar> | undefined;

export const SnackbarUtilsConfigurator: React.FC = () => {
  useSnackbarRef = useSnackbar();
  return null;
};

function resolveMessage(msg: string): string {
  const trimmed = typeof msg === "string" ? msg.trim() : "";
  if (!trimmed) {
    return i18n.t("common.tip.commonErrorMessage");
  }
  return trimmed;
}

const notistackPlus = {
  toast(msg: string, variant: VariantType = "default") {
    useSnackbarRef?.enqueueSnackbar(resolveMessage(msg), { variant });
  },
  success(msg: string) {
    notistackPlus.toast(msg, "success");
  },
  warning(msg: string) {
    notistackPlus.toast(msg, "warning");
  },
  info(msg: string) {
    notistackPlus.toast(msg, "info");
  },
  error(msg: string) {
    notistackPlus.toast(msg, "error");
  },
};

export default notistackPlus;
